const fields = new Map();

export const useFormValidator = () => {
	return {
		registerField: (name, validate, scrollToAndFocus) =>
			fields.set(name, { name, validate, scrollToAndFocus }),
		unregisterField: (name) => fields.delete(name),
		isValid: (noFocus = false) => {
			let valid = true;

			fields.forEach((field) => {
				const fieldValid = field.validate();

				// Focus first invalid field
				if (!noFocus && !fieldValid && valid) {
					field.scrollToAndFocus();
					valid = false;
				}
			});

			return valid;
		},
		update: (fieldsToUpdate) => {
			let valid = true;

			fields.forEach((field) => {
				if (fieldsToUpdate[field.name]) {
					const fieldValid = field.validate(fieldsToUpdate[field.name]);

					// Focus first invalid field
					if (!fieldValid && valid) {
						field.scrollToAndFocus();
						valid = false;
					}
				}
			});

			return valid;
		},
	};
};
